export const baseUrl = "https://imstest.ekedc.com/api/businesscard";



